import React from 'react';
import { useTranslation } from 'react-i18next';

import ProjectItem from './ProjectItem';
import { ConfirmModal } from 'components/Modal/ConfirmModal';
import ProjectCloneModal from 'components/Modal/ProjectCloneModal';
import { sortBy } from 'lodash';
import { Row, Col } from 'antd';

interface ProjectListProps {
	list: [],
	onSelectProject: (project: any) => {},
	onClone: (id: string, values: any) => {},
	onDelete: (id: string) => {},
	canClone: false,
	refetch: () => {},
	pushModal: (modal: any) => {},
	authorizedProjectTypes: {
		pro: boolean,
		stakeholders: boolean,
		risks: boolean
	}
};

// Projet partagé AVEC moi (lecteur ou éditeur), par opposition à un projet
// dont je suis propriétaire (myRole 'owner').
const isSharedWithMe = (project: any) =>
	project?.myRole === 'reader' || project?.myRole === 'editor';

export const ProjectsList = (props: ProjectListProps) => {
	const { t } = useTranslation();

	const askDeleteConfirmation = async (id?: string, name?: string) => {
		props.pushModal(
			<ConfirmModal
				title={t('models.project.messages.delete_confirmation')}
				t={t}
				onConfirm={() => props.onDelete(id)}
				message={t(
					'models.project.messages.delete_confirmation_explanation', {
					name
				}
				)}
			></ConfirmModal>
		);
	};

	const askCloneConfirmation = async (id, values) => {
		props.pushModal(
			<ProjectCloneModal
				onSave={(values: Object) => {
					props.onClone(id, {
						name: values.name,
						type: values.type,
						reference: values.reference,
					});
				}}
				id={values?.id}
				key={values?.id || 'new'}
				values={{
					name: values?.name + ' - Copy',
					reference: "",
					type: values?.type && props.authorizedProjectTypes && props.authorizedProjectTypes[values?.type] ? values?.type : null
				}}
				authorizedTypes={props.authorizedProjectTypes}
			></ProjectCloneModal>
		)
	}

	return (
		<>
			<Row gutter={[8, 8]} justify={"center"} className="ProjectsList mb-1">
				{
					sortBy((props.list || []), ["name", "reference", "createdAt"]).map((value: any, index: Number) => (
						<Col xs={24} sm={22} md={11} lg={8} xl={7} key={value?.id}>
							<ProjectItem
								onDelete={() => {
									askDeleteConfirmation(value?.id, value?.name);
								}}
								onClick={props.onSelectProject}
								// Seul le propriétaire peut cloner (la Lambda refuse les membres) :
								// pas d'action « cloner » sur un projet partagé avec moi.
								onClone={
									props.canClone && !isSharedWithMe(value)
										? (e: any) => {
											askCloneConfirmation(
												value?.id,
												value
											);
											return false;
										}
										: null
								}
								key={value?.id}
								details={value}
							></ProjectItem></Col>
					))
				}

			</Row>
		</>
	);
};